import { useState } from "react";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";

export function ForgotPasswordDialog({ open, onOpenChange, initialEmail = "" }) {
  const [email, setEmail] = useState(initialEmail);
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try { const { data } = await api.post("/auth/forgot-password", { email }); setMsg(data.message); }
    catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { onOpenChange(o); if (!o) setMsg(""); }}>
      <DialogContent className="max-w-sm" data-testid="forgot-password-dialog">
        <DialogHeader>
          <DialogTitle className="font-display">Forgot password</DialogTitle>
          <DialogDescription>Enter your login email and we will email you a link to choose a new password. You can also ask the owner to reset it from Team.</DialogDescription>
        </DialogHeader>
        {msg ? <div className="rounded-lg border border-emerald-200 bg-emerald-50 p-3 text-sm text-emerald-800" data-testid="forgot-password-sent">{msg}</div> : (
          <form onSubmit={submit} className="space-y-4">
            <div className="space-y-1"><Label>Email</Label><Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="h-11 bg-white" data-testid="forgot-email-input" /></div>
            {error && <div className="text-sm text-rose-700" data-testid="forgot-error">{error}</div>}
            <Button type="submit" disabled={busy} className="h-11 w-full rounded-full bg-[#0F382C] hover:bg-[#134E3A]" data-testid="forgot-submit-btn">
              {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Send reset link"}
            </Button>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
}
